<template>
  <img
    src="https://static.wangsu.com/lib/images/status/v1/404.min.svg"
    alt="404"
  />
</template>
<script setup lang="ts">
import { defineComponent } from 'vue'

defineComponent({
  name: 'ElResultIcon404',
})
</script>
